export default __webpack_public_path__ + "static/media/eye.7b6d1196.svg";